/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Model_LabelInputs */



/**
* | output |
* | --- |
* | "Agent model" |
*
* @param {Assistant_Model_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_model_label = /** @type {((inputs?: Assistant_Model_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Model_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modèle d'agent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Agentenmodell")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modello agente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Модель агента")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modelo de agente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代理模型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エージェントモデル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एजेंट मॉडल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modelo de agente")
	return /** @type {LocalizedString} */ ("Agent model")
});